



import {Component, Prop} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ValidationFormMixin} from "@/mixins";
import TextInput from "@/components/Atoms/TextInput/TextInput.vue";
import TextInputGroup from "@/components/Molecules/TextInputGroup/TextInputGroup.vue";
import AuthCard from "@/components/Organisms/AuthCard/AuthCard.vue";
import CardHeader from "@/components/Atoms/CardHeader/CardHeader.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";
import {ChangePasswordFormType} from "@/share";

@Component({
  components: {TextInput, TextInputGroup, AuthCard, CardHeader, ButtonSuccessful}
})
export default class ChangePasswordForm extends mixins(ValidationFormMixin) {
  @Prop({type: Boolean, default: false}) isLoading!: boolean
  @Prop(String) error?: string

  private formData: ChangePasswordFormType = new ChangePasswordFormType({
    password: '',
    passwordConfirmation: '',
    token: this.$route.query.token || ''
  })

  private changePassword(value: string): void {
    this.formData.password = value
  }

  private changePasswordConfirmation(value: string): void {
    this.formData.passwordConfirmation = value
  }

  private async submit(): Promise<void> {
    const isValid = await this.validateForm()
    if (!isValid) return

    this.$emit('submit', this.formData)
  }
}
